/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ICardFieldProps } from "../cards/CardField"
import { useEffect } from "react"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import { __ } from "src/libs/utilities"
import { Link } from "react-router-dom"

const CardFieldInnerLink = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props
    useEffect(() => {
            const height = getCssDemention(field.style?.height, "120px") 
            const paddingBottom = getCssDemention(field.style?.paddingBottom, "0px") 
            addCSSClass(
                `landing-card-field-inner-link-${section.id + "-" + value?.id}`,
                `.landing-card-field-inner-link-${section.id + "-" + value?.id} {
                    height: ${height}!important;
                    max-height: ${height}!important;
                    padding-bottom:${paddingBottom}!important;
                } 
                `
            )
            return () => removeCSSClass(`landing-card-field-inner-link-${section.id + "-" + value?.id}`)
        }, [])

    const style = { 
        ...field.style, 
        ...value.style 
    }
    style.backgroundColor = undefined
    return <div 
        className={`landing-card-field landing-card-field-inner-link landing-card-field-inner-link-${section.id + "-" + value.id}`} 
        style={ style } 
        data-card-field-id={i} 
        card-field-section-id={section.id}
    > 
        <Link className="m-0" to={value?.data?.url} >
            <div 
                className={ `btn btn-primary ${field.className || ""} ` } 
                style={value?.data?.style}
            >
            {
                typeof value?.data?.label === "string"
                    ?
                    __(value?.data?.label)
                    :
                    value?.data?.label
            }    
            </div>
            
        </Link>
    </div>
}
export default CardFieldInnerLink